import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RoutePaths } from './shared/navigation/route-paths';

import { accountRoutes } from './account/account.routing';
import { componentShowcaseRoutes } from './components-showcase/components-showcase.routing';
import { iphoneRoutes } from './iphone/iphone.routing';
import { loginRoutes } from './login/login.routing';
import { AccessGuard } from './shared/guards/access-guard';
import { pageNotFoundRoutes } from './page-not-found/page-not-found.routing';
import { resetPasswordRoutes } from './reset-password/reset-password.routing';
import { switchAccountRoutes } from './switch-account/switch-account.routing';
import { updateWarningRoutes } from './update-warning/update-warning.routing';
import { waiterMobileRoutes } from './waiter/waiter-mobile/waiter-mobile.routing';
import { AuthenticationGuard } from './shared/guards/authentication-guard';

export const appRoutes: Routes = [
  ...resetPasswordRoutes,
  ...loginRoutes,
  ...componentShowcaseRoutes,
  ...updateWarningRoutes,
  ...pageNotFoundRoutes,
  ...switchAccountRoutes,
  {
    path: RoutePaths.EMPTY,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: RoutePaths.EMPTY,
        redirectTo: `/${RoutePaths.DASHBOARD}`,
        pathMatch: 'full'
      },
      {
        path: RoutePaths.DASHBOARD,
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivate: []
      },
      {
        path: RoutePaths.REPORTS,
        loadChildren: './reports/reports.module#ReportsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.COMBINED_REPORTS,
        loadChildren:
          './combined-reports/combined-reports.module#CombinedReportsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.USERS,
        loadChildren:
          './user-management/user-management.module#UserManagementModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.PRODUCTS,
        loadChildren: './products/products.module#ProductsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.FLOORS,
        loadChildren: './floors/floors.module#FloorsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.DEVICES,
        loadChildren:
          './device-management/device-management.module#DeviceManagementModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.PRINTING,
        loadChildren: './printing/printing.module#PrintingModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.PAYMENTS,
        loadChildren: './payments/payments.module#PaymentsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.FINANCIAL_SERVICES,
        loadChildren:
          './financial-services/financial-services.module#FinancialServicesModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.SETTINGS,
        loadChildren: './settings/settings.module#SettingsModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.SUPPORT,
        loadChildren: './support/support.module#SupportModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.WAITER,
        loadChildren: './waiter/waiter/waiter.module#WaiterModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.TASKS,
        loadChildren: './tasks/tasks.module#TasksModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.LS_ACCOUNTING,
        loadChildren: './ls-accounting/ls-accounting.module#LsAccountingModule',
        canActivate: [AccessGuard]
      },
      {
        path: RoutePaths.INTEGRATIONS,
        loadChildren: './integrations/integrations.module#IntegrationsModule',
        canActivate: [AccessGuard]
      },
      ...waiterMobileRoutes,
      ...iphoneRoutes,
      ...accountRoutes
    ]
  },
  {
    path: '**',
    redirectTo: `/${RoutePaths.NOT_FOUND}`,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false, // <-- debugging purposes only
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
